import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import Page from '../Page';
import PageSection from '../PageSection';
import Table from '../Table';

var Auth = new AuthService();

class SizingFormStatus extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();

		this.sizing_form_status = this.props.match.params.sizing_form_status;
		this.state = {
			tableData: {
				heading: [],
				body: []
			},
			noResultsMessage: <p className="pp-loading">Loading sizing forms</p>
		}

		this.Auth.fetch('/prediction/sizing-form?status=' + this.sizing_form_status)
			.then((result) => {
				let header = ['Boat', 'Date ' + this.sizing_form_status, this.sizing_form_status + ' By'],
					rows = [];
				if (result.success === true) {

					this.setState({
						noResultsMessage: "You have no " + this.sizing_form_status + " sizing forms"
					});

					for (let a = 0; a < result.data.length; a += 1) {
						let data = result.data[a],
							row = [];
						if (this.sizing_form_status === 'published') {
							row.push(<a href={"/report/" + data.report_id}>{data.builder_name} {data.model_name} {data.boat_year}</a>);
						} else {
							row.push(<a href={"/sizing-form/" + data.sizing_form_id}>{data.builder_name} {data.model_name} {data.boat_year}</a>);
						}
						row.push(data.created_date);
						row.push(data[this.sizing_form_status + '_first_name'] + ' ' + data[this.sizing_form_status + '_last_name']);
						rows.push(row);
					}

					this.setState({
						tableData: {
							heading: header,
							body: rows
						}
					});
				}
			});
	}
	render() {

		return (
			<Page
				pageTitle={this.sizing_form_status + " Sizing Forms"}
				pageClass="pp-view-all-report-page"
			>
				<PageSection
					className="pp-table-section"
				>
					<Table
						tableHeading={this.state.tableData.heading}
						tableBody={this.state.tableData.body}
						noResultsMessage={this.state.noResultsMessage}
					/>
				</PageSection>
			</Page>
		);
	}
}

export default SizingFormStatus;



// WEBPACK FOOTER //
// ./src/components/pages/SizingFormStatus.js